export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ourPets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waiting for You"])},
        "morePets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our Pets!"])},
        "ourSitters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your Pet in save Hands"])},
        "moreSitters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our Sitters!"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["See more"])}
      },
      "de": {
        "ourPets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie warten auf dich"])},
        "morePets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsere Haustiere!"])},
        "ourSitters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dein Tier in guten Händen"])},
        "moreSitters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsere Sitter!"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfahre mehr"])}
      }
    }
  })
}